import { httpMethods } from "../constants/appConstants";
import { CMS_ERRORS, CONTACT_FORM_ERROR } from "../constants/sentryConstants";
import { captureSentryException } from "../errors/SentryErrors";
import { sendRequest } from "../helper/serviceHandler/handler";

export const contact = async (formData: any) => {
  try {
    const response = await sendRequest(httpMethods.POST, `/contact`, formData);
    return response?.data;
  } catch (error) {
    const { message, code } = CONTACT_FORM_ERROR.CONTACT_FORM;
    captureSentryException(message, error, code);
    console.error("Error submitting Contact form:", error);
    throw error;
  }
};
